<template>
    <svg
        class="icon"
        :class="name"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
        v-html="paths"
    ></svg>
</template>

<script setup>
import {computed} from 'vue';
import icons from './remixicons';

const props = defineProps({name: {type: String, required: true}});
// SVG markup comes exclusively from the installed Remixicon package, never from user input.
const paths = computed(() => (icons[props.name] || '').trim().replace(/^<svg\b[^>]*>/, '').replace(/<\/svg>$/, ''));
</script>
